import { motion } from "framer-motion";
import { usePlatform } from "./PlatformContext";

const LoadingPanel = () => {
  // Get the platform context
  const { platform, logo } = usePlatform();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{
        opacity: 1,
        transition: {
          duration: 1,
          repeat: Infinity,
          ease: "easeInOut",
          repeatType: "mirror",
        },
      }}
      transition={{duration: 0.5, ease: "easeOut"}}
      exit={{ opacity: 0 }}
      className="fixed w-full h-full inline-flex justify-center items-center"
    >
      <img
        className={
          platform === "codeflix" ? "w-[124px] h-10" : "w-[85.57px] h-14"
        }
        src={logo}
      />
    </motion.div>
  );
};

export default LoadingPanel;
